const defaultFormatter = v => v;

export default {
  methods: {
    getQueryParam(name, fallback, formatter = defaultFormatter) {
      const param = this.$route.query[name];

      if (param === undefined) {
        return typeof fallback === 'function' ? fallback() : fallback;
      }

      return formatter(param);
    },

    getQueryParams(params) {
      const result = {};

      params.forEach(item => {
        const [name, fallback, formatter] =
          typeof item === 'string'
            ? [item]
            : [item.key, item.default, item.format];

        result[name] = this.getQueryParam(name, fallback, formatter);
      });

      return result;
    },

    setQuery(query) {
      let obj = Object.assign({}, this.$route.query);

      Object.keys(query).forEach(key => {
        let value = query[key];
        if (value) {
          obj[key] = value;
        } else {
          delete obj[key];
        }
      });

      return this.$router.replace({
        ...this.$router.currentRoute,
        query: obj
      });
    },

    removeQuery(props) {
      let obj = {};

      props.forEach(key => {
        obj[key] = null;
      });

      return this.setQuery(obj);
    }
  }
};
